import type { ReactNode } from 'react'

import { cn } from 'cn'

/** Shared box for every bottom-bar item so icons line up. */
export const bottomNavItemClassName =
  'group flex h-[4.25rem] min-w-14 flex-1 flex-col items-center pt-3 text-white/55 transition-colors outline-none hover:text-white/80 focus-visible:text-white active:scale-95'

interface BottomNavItemContentProps {
  icon: ReactNode
  label: string
  active?: boolean
}

/**
 * Icon, glowing indicator and label. Inactive items show the icon only (label space is reserved
 * so nothing shifts); the active item turns orange, lights its indicator and reveals its label.
 */
export function BottomNavItemContent({ icon, label, active = false }: BottomNavItemContentProps) {
  return (
    <>
      <span className={cn('flex size-6 items-center justify-center transition-colors', active && 'text-primary')}>
        {icon}
      </span>
      <span
        aria-hidden
        className={cn(
          'mt-1.5 h-1 rounded-full transition-all duration-300 ease-out-expo',
          active ? 'w-7 bg-primary shadow-[0_0_12px_1px_rgb(252_76_2/0.7)]' : 'w-0 bg-transparent',
        )}
      />
      <span
        aria-hidden
        className={cn(
          'mt-1 text-[11px] leading-4 font-semibold whitespace-nowrap text-white transition-all duration-300',
          active ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0',
        )}
      >
        {label}
      </span>
    </>
  )
}
